<template>
  <div>
    <div v-if="showTrashIcon">
      <b-button
        v-ripple.400="'rgba(234, 84, 85, 0.15)'"
        variant="outline-danger"
        class="btn-icon rounded-circle"
        @click="remove()"
      >
        <feather-icon
          icon="TrashIcon"
        />
      </b-button>
    </div>
    <div v-else>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        class="btn-icon rounded-circle"
        variant="outline-primary"
        @click="confirm"
      >
        <feather-icon icon="CheckIcon" />
      </b-button>
      <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          class="btn-icon rounded-circle"
          variant="outline-primary"
          @click="cancel"
          style="margin-right: 0.5rem"
      >
        <feather-icon icon="XIcon" />
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Trash',
  props: {
    index: { type: Number, default: null },
    value: { type: Array, default: null },
  },
  data() {
    return {
      showTrashIcon: true,
    }
  },
  methods: {
    remove() {
      this.showTrashIcon = false
    },
    confirm() {
      this.value.splice(this.index, 1)
      this.$emit('input', this.value)
      this.showTrashIcon = true
    },
    cancel() {
      this.showTrashIcon = true
    },
  },
}
</script>

<style scoped>

</style>
